import {routing as routingShared} from '@cl/shared';
import type {RouteDomainSpecificFunctions} from '../routing.types';
import {RouteKey} from '../routing.enums';

function registerDomainSpecificRouteFunctions(
  routeKey: RouteKey,
  domainSpecificFunctions: RouteDomainSpecificFunctions,
) {
  routingShared.allRouteDefs[routeKey] = {
    ...routingShared.allRouteDefs[routeKey],
    ...domainSpecificFunctions,
  };
}

export default registerDomainSpecificRouteFunctions;
